module.exports = __webpack_public_path__ + "img/ic-cube-warning.35e7df90.svg";